module.exports = __webpack_public_path__ + "static/media/login-cupcake.6e13eaba.png";